export default __webpack_public_path__ + "static/jen-ra-dbdbd2d71a665ae0c2f37cbc1b6c5f45.png";